import React from 'react';
import { PackeryLoadingProvider } from  '../context/PackeryContext';
import { StorageAPIProvider } from '../context/StorageContext';
import PropTypes from 'prop-types';

const withPackeryLoading = (Component) => {
    function WithPackeryLoading(props) {
        return (
            <StorageAPIProvider storageKey={props.storageKey}>
                <PackeryLoadingProvider componentsCount={props.childrenLength} componentName={props.componentName} >
                    <Component {...props} />
                </PackeryLoadingProvider>
            </StorageAPIProvider>
        );
    }

    WithPackeryLoading.propTypes = {
        storageKey: PropTypes.string.isRequired,
        childrenLength: PropTypes.number.isRequired,
        componentName: PropTypes.string.isRequired
    };

    return WithPackeryLoading;
}

export default withPackeryLoading;